import React from 'react'
import { Popover, Space } from 'antd'
import { Link } from 'react-router-dom'


export const columns = (setCurrentOrder, setShowModal) => [
    {
        title: 'Car',
        dataIndex: 'name',
        key: 'name',
        width: 200,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <Space size="middle">
                {/* eslint-disable-next-line */}
                <Popover
                    content={
                        <div>
                            <img
                                src={record.car.image}
                                height={150}
                                width={150}
                                alt="car thumbnail"
                            />
                        </div>
                    }
                    title={`Current Price: ${record.car.profitCurrency?.symbol} ${record.car.price}`}
                    trigger="hover"
                >
                    <div>
                        <div>
                            <b>Car:</b> {`${record.car.year} ${record.car.make.name} ${record.car.model.name} ${record.car.trim}`}
                        </div>
                        <div>
                            <b>Chassis #:</b> {record.car.chassisNo}
                        </div>
                    </div>
                </Popover>
            </Space>
        )
    },
    {
        title: 'Purchased Price',
        dataIndex: 'pricePerUnit',
        key: 'pricePerUnit',
        width: 180,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <Space size="middle" style={{ display: 'flex', flexDirection: 'column' }}>
                {/* eslint-disable-next-line */}
                <div>
                    {record.car.profitCurrency?.symbol}
                    {record.car.price}
                </div>
                <div>
                    (@{record.pricePerUnit} * {record.quantity})
                </div>
            </Space>
        )
    },
    {
        title: 'Payment Status',
        dataIndex: 'paymentStatus',
        key: 'paymentStatus',
        width: 120
    },
    {
        title: 'Delivery Status',
        dataIndex: 'deliveryStatus',
        key: 'deliveryStatus',
        width: 120
    },
    {
        title: 'ETA',
        dataIndex: 'eta',
        key: 'eta',
        width: 120,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <div>
                {record.eta ? (
                    <>
                        <div>{new Date(record.eta).toDateString()}</div>
                    </>
                ) : (
                    'N/A'
                )}
            </div>
        )
    },
    {
        title: 'Shipping Company',
        dataIndex: 'shippingCompany',
        key: 'shippingCompany',
        width: 120,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <div>
                {record.shippingCompany ? (
                    <>
                        <div>{record.shippingCompany.name} - {record.shippingCompany.origin.country}</div>
                    </>
                ) : (
                    'N/A'
                )}
            </div>
        )
    },
    {
        title: 'Customer',
        dataIndex: 'user',
        key: 'user',
        width: 120,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <div>
                <div>{record.user.firstName}</div>
                <div>{record.user.phoneNumber}</div>
            </div>
        )
    },
    {
        title: 'Container / B/L',
        dataIndex: 'containerNumber',
        key: 'containerNumber',
        width: 140,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <div>
                {record.containerNumber || record.billOfLading ? (
                    <>
                        {record.containerNumber ? <div>{record.containerNumber}</div> : null}
                        {record.billOfLading ? <div>B/L {record.billOfLading}</div> : null}
                    </>
                ) : (
                    'N/A'
                )}
            </div>
        )
    },
    {
        title: 'Order Date',
        dataIndex: 'orderedOn',
        key: 'orderedOn',
        width: 120,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <div>
                {record.orderedOn ? (
                    <>
                        <div>{new Date(record.orderedOn).toDateString()}</div>
                    </>
                ) : (
                    'N/A'
                )}
            </div>
        )
    },
    {
        title: 'Order Note',
        dataIndex: 'note',
        key: 'note',
        width: 120
    },
    {
        title: 'Date Added',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 150,
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
            <Space size="middle">
                <span>{new Date(record.createdAt).toDateString()}</span>
            </Space>
        )
    },
    {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 150,
        // eslint-disable-next-line react/display-name
        render: (_, record) => (
            <Space size="middle">
                <Link
                    to={'#'}
                    onClick={() => {
                        setCurrentOrder(record)
                        setShowModal(true)
                    }}
                >
                    Update
                </Link>
                <Link to={`/car-orders/${record.id}`}>View</Link>
            </Space>
        )
    }
]